import nodeApiService from "../../../services/nodeApiService"

export const callArtworksResultsApi = (params) => {
  const callback = !params.page
    ? nodeApiService.search
    : nodeApiService.artworks
  return callback(params)
}
